import { createDonut } from '../factories/createDonut';
import { attachDonutInput, ensureDonutHomePosition } from './InputSystem';
import { GAME_CONFIG } from '../config/GameConfig.js';

export function setTheGrid(scene) {

    /*
    ///////////////////////////////////////////////////
    // first we'll build the grid

    const totalWidth = scene.cols * scene.cellWidth;
    const totalHeight = scene.rows * scene.cellHeight;

    // Properly centered grid origin
    scene.gridStartX = (scene.cameras.main.width - totalWidth) / 2 + scene.cellWidth / 2;
    scene.gridStartY = 80 + scene.cellHeight / 2;
    */

    //////////////////////////////////////////////////////////////////////////
    // testing
    const screenWidth = scene.cameras.main.width;
    const screenHeight = scene.cameras.main.height;

    // --------------------------------------------------
    // Calculate the largest cell size that can fit
    // the entire game vertically and horizontally.
    // --------------------------------------------------

    //const topPadding = scene.gridTopPadding ?? 80;
    const topPadding = scene.gridTopPadding ?? 235;
    const bottomSpacing = scene.gridBottomSpacing ?? 40;
    const timerHeight = scene.timerBoxHeight ?? 60;
    const bottomPadding = scene.bottomPadding ?? 20;

    // Space available for the actual donut grid
    const availableGridHeight = screenHeight - topPadding - bottomSpacing - timerHeight - bottomPadding;

    // Maximum size allowed for a single donut/cell
    const maxCellSize = scene.maxCellSize ?? 60;

    // How large each cell could be based on width
    const cellSizeFromWidth = screenWidth / scene.cols;

    // How large each cell could be based on height
    const cellSizeFromHeight = availableGridHeight / scene.rows;

    // Use the largest size that satisfies BOTH dimensions.
    const calculatedCellSize = Math.min(cellSizeFromWidth, cellSizeFromHeight, maxCellSize);

    // Keep cells square.
    scene.cellWidth = calculatedCellSize;
    scene.cellHeight = calculatedCellSize;

    const totalWidth = scene.cols * scene.cellWidth;
    const totalHeight = scene.rows * scene.cellHeight;

    // --------------------------------------------------
    // Center the grid horizontally.
    // --------------------------------------------------

    scene.gridStartX = (screenWidth - totalWidth) / 2 + scene.cellWidth / 2;

    // --------------------------------------------------
    // Position the grid below the top UI.
    // --------------------------------------------------

    scene.gridStartY = topPadding + scene.cellHeight / 2;

    scene.items = [];
    scene.grid = [];
    //////////////////////////////////////////////////////////////////////////

    scene.items = [];
    scene.grid = [];

    for ( let row = 0; row < scene.rows; row++) {
        scene.grid[row] = [];

        for (let col = 0; col < scene.cols; col++) {

            const index = row * scene.cols + col;

            const type = getSafeRandomType(scene, col, row);

            const donut = createDonut(scene, col, row, type);

            // Place into logical grid
            scene.grid[row][col] = donut;

            scene.items.push(donut);

            // Animate into correct position
            moveToGridPosition(scene, donut, true, index);

            attachDonutInput(scene, donut);
        }
    }

    /*
    // Calculate grid center X
    const gridCenterX = scene.cameras.main.width / 2;

    // Calculate bottom of grid
    const gridBottomY = scene.gridStartY + totalHeight;

    //scene.time.delayedCall( 300, () => scene.checkMatches());

    ///////////////////////////////////////////////////

    // Spacing below grid
    const spacing = 40;

    const timerBoxWidth = 240;
    const timerBoxHeight = 60;

    const timerBoxY = gridBottomY + spacing;
    */

    ///////////////////////////////////////////////////
    //testing
    const gridCenterX = scene.cameras.main.width / 2;

    const gridBottomY = scene.gridStartY + totalHeight - scene.cellHeight / 2;

    const spacing = scene.gridBottomSpacing ?? 40;

    const timerBoxWidth = scene.timerBoxWidth ?? 240;
    const timerBoxHeight = scene.timerBoxHeight ?? 60;

    const timerBoxY = gridBottomY + spacing + timerBoxHeight / 2;
    ///////////////////////////////////////////////////

    scene.time.delayedCall(300, () => scene.checkMatches());

    /*
    // Add neon container centered
    const timerBox = scene.add.image(gridCenterX, timerBoxY, 'neonContainer');

    timerBox.setDisplaySize(timerBoxWidth, timerBoxHeight);

    scene.remainingTime = scene.startTime;

    scene.timerText = scene.add.text(
        gridCenterX,
        timerBoxY,
        '',
        {
            fontSize: '28px',
            fontStyle: 'bold',
            color: '#F1CE4C'
        }
    ).setOrigin(0.5);

    scene.startTimer();
    */
}


export function getRandomType(scene, excludeTexture = null) {

    let availableTypes = scene.donutTypes;

    if (excludeTexture !== null) {

        availableTypes = scene.donutTypes.filter(t => t.texture !== excludeTexture);
    }

    return Phaser.Utils.Array.GetRandom(availableTypes);
}


export function getSafeRandomType(scene, col,row) {

    let type;
    let attempts = 0;

    do {
        type = Phaser.Utils.Array.GetRandom(scene.donutTypes);
        attempts++;
    } while (wouldCreateMatch(scene, col, row, type) && attempts < 10);

    return type;
}


export function wouldCreateMatch(scene, col, row, type) {
    const value = type.value;

    // -------------------------
    // check LEFT (horizontal)
    // -------------------------

    let count = 1;

    for (let c = col - 1; c >= 0; c--) {

        const item = scene.grid[row]?.[c];

        if (!item || item.type.value !== value) {
            break;
        }

        count++;
    }

    if (count >= 3) {
        return true;
    }

    // -------------------------
    // check UP (vertical)
    // -------------------------

    count = 1;

    for (let r = row - 1; r >= 0; r--) {

        const item = scene.grid[r]?.[col];

        if (!item || item.type.value !== value) {
            break;
        }

        count++;
    }

    if (count >= 3) {
        return true;
    }

    return false;
}


export function getWorldPosition(scene, col, row) {

    return {
        x: scene.gridStartX + col * scene.cellWidth,
        y: scene.gridStartY + row * scene.cellHeight
    };
}


export function moveToGridPosition(
    scene,
    item,
    animate = true,
    delayIndex = 0
) {

    const pos =
        getWorldPosition(
            scene,
            item.gridCol,
            item.gridRow
        );


    // ------------------------------------------------------------
    // The logical grid position is ALWAYS the donut's home
    // position.
    // ------------------------------------------------------------

    item.homeX =
        pos.x;


    item.homeY =
        pos.y;


    if (!animate) {

        item.setPosition(
            pos.x,
            pos.y
        );

        return;
    }


    scene.tweens.add({
        targets: item,
        x: pos.x,
        y: pos.y,
        duration: GAME_CONFIG.swapDuration,
        ease: 'Back.out',
        delay: delayIndex * 40
    });
}


export function moveItemTo(scene, item, newCol, newRow) {

    // Remove from old grid slot
    scene.grid[item.gridRow][item.gridCol] = null;

    // Update logical position
    item.gridCol = newCol;
    item.gridRow = newRow;

    // Place into new slot
    scene.grid[newRow][newCol] = item;

    // Animate to new position
    moveToGridPosition(scene, item, true);
}


export function spawnReplacement(scene, oldItem) {

    const col = oldItem.gridCol;
    const row = oldItem.gridRow;

    // Prevent double clicking while animating
    oldItem.disableInteractive();

    // Shrink animation
    scene.tweens.add({
        targets: oldItem,
        scale: 0,
        duration: 200,
        ease: 'Power2',

        onComplete: () => {

            // Remove from logical grid
            scene.grid[row][col] = null;

            // Remove from items array
            const index = scene.items.indexOf(oldItem);

            if (index !== -1) {
                scene.items.splice(index, 1);
            }

            oldItem.destroy();

            // Apply gravity AFTER shrink completes
            applyGravity(scene, col, row);

            // Spawn new item at top
            spawnNewAtTop(scene, col);
        }
    });
}


export function applyGravity(scene, colremovedRow) {

    for (let r = removedRow - 1; r >= 0; r--) {

        const itemAbove = scene.grid[r][col];

        if (itemAbove) {
            scene.grid[r][col] = null;

            scene.grid[r + 1][col] = itemAbove;

            itemAbove.gridRow += 1;

            moveToGridPosition(scene, itemAbove, true);
        }
    }

    scene.time.delayedCall(GAME_CONFIG.swapDuration, () => scene.checkMatches());
}


export function spawnNewAtTop(scene,  col) {

    const type = getRandomType(scene);

    /*
    NOTE:
    This preserves the existing source exactly.
    The original implementation references `row`
    here even though `row` is not defined.
    This function is currently not part of the
    active matching/refill path.
    */

    const donut = createDonut(scene, col, row, type);

    scene.grid[0][col] = donut;
    scene.items.push(donut);

    moveToGridPosition(scene, donut, true);

    // pop-in animation
    //donut.setScale(0);

    scene.tweens.add({
        targets: donut,
        //scale: 0,
        duration: 180,
        ease: 'Back.out'
    });

    attachDonutInput(scene, donut);
}


export function spawnNewAtPosition(
    scene,
    col,
    row
) {

    const type =
        getRandomType(scene);


    const spawnPos =
        getWorldPosition(
            scene,
            col,
            row
        );


    const donut =
        scene.add.image(
            spawnPos.x,
            scene.gridStartY -
                scene.cellHeight * 2,
            type.texture
        );


    donut.setOrigin(0.5);


    donut.setDisplaySize(
        scene.cellWidth - 10,
        scene.cellHeight - 10
    );


    donut.setInteractive({
        useHandCursor: true
    });


    donut.type =
        type;


    donut.value =
        type.value;


    donut.gridCol =
        col;


    donut.gridRow =
        row;


    scene.grid[row][col] =
        donut;


    scene.items.push(
        donut
    );


    moveToGridPosition(
        scene,
        donut,
        true
    );


    scene.tweens.add({
        targets: donut,
        duration: 180,
        ease: 'Back.out'
    });


    // ------------------------------------------------------------
    // IMPORTANT:
    // Use the SAME input system as every other donut.
    // ------------------------------------------------------------

    attachDonutInput(
        scene,
        donut
    );
}

/*
function attachRefillInput(scene, donut) {

    donut.on('pointerdown', (pointer) => {

        if (scene.disableInput || scene.isSwapping) {
            return;
        }

        scene.pointerDownItem = donut;

        scene.pointerStartX = pointer.x;

        scene.pointerStartY = pointer.y;

        donut.originalX = donut.x;
        donut.originalY = donut.y;

        scene.isDragging = false;
        scene.lockedAxis = null;
    });


    donut.on('dragstart', () => {

        if (scene.disableInput) return;

        donut.setDisplaySize(scene.cellWidth + 20 - 10, scene.cellHeight + 20 - 10);
    });


    donut.on('drag', (pointer, dragX, dragY) => {

        if (scene.disableInput) return;

        donut.x = dragX;
        donut.y = dragY;
    });


    donut.on('dragend', () => {

        if (scene.disableInput) return;

        donut.setDisplaySize(scene.cellWidth - 10, scene.cellHeight - 10);
    });
}
*/

export function collapseGrid(scene) {

    for (let col = 0; col < scene.cols; col++) {

        for (let row = scene.rows - 1; row >= 0; row--) {

            if (scene.grid[row][col] === null) {

                // Look upward for next item
                for (let r = row - 1; r >= 0; r--) {

                    if (scene.grid[r][col] !== null) {

                        const item = scene.grid[r][col];

                        scene.grid[r][col] = null;

                        scene.grid[row][col] = item;

                        item.gridRow = row;

                        moveToGridPosition(scene, item, true);

                        break;
                    }
                }
            }
        }
    }

    // Refill empty spaces
    scene.time.delayedCall(GAME_CONFIG.swapDuration, () => refillGrid(scene));
}


export function refillGrid(scene) {

    for (let col = 0; col < scene.cols; col++) {
        for (let row = 0; row < scene.rows; row++) {
            if (scene.grid[row][col] === null) {
                spawnNewAtPosition(scene, col, row);
            }
        }
    }

    // Check for chain reactions
    scene.time.delayedCall(GAME_CONFIG.swapDuration, () => scene.checkMatches());
}